import { render, staticRenderFns } from "./cnzz.vue?vue&type=template&id=80f03100&scoped=true&"
import script from "./cnzz.vue?vue&type=script&lang=js&"
export * from "./cnzz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f03100",
  null
  
)

export default component.exports